import React, { Component } from "react";
import { connect } from "react-redux";
import Form from "react-jsonschema-form-bs4";
import Geyser from "../Geyser/Geyser";
import VehicleCollision from "../VehicleCollision/VehicleCollision";
import schema from "wn-claims-shared/dist/schema/form-selection-schema";
import baseUiSchema from "./uiSchema";
import $ from "jquery";
import axios from "axios";
import config from "../../config.json";
import { setFormSelectionData, clearFormSelectionData } from "../../store/actions";

const uuidv4 = require("uuid/v4");
const log = (type) => console.log.bind(console, type);

export class FormSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formSchema: JSON.parse(JSON.stringify(schema)),
      selectedForm: {},
      previousCauseOfLoss: null,
      previousNonMotor: null,
      previousCOI: null,
      isMounted: true,
      productTypesLoaded: false,
      productTypeIdByName: {},
      perilIdByName: {},
      causeIdByName: {},
      previousBaseCoiId: null,
      previousClaimMotorId: null,
      previousClaimNonMotorId: null,
      previousSubCoiId: null,
      loadingCauses: false,
      loadingSubCoi: false,
      loadingPeril: false,
      uiSchema: { ...baseUiSchema }
    };
    this.selectedForm = {};
    // Store event listener references
  }

  componentDidMount() {
    this.fetchProductTypes();
  }

  componentDidUpdate(prevProps, prevState) {
    // Re-apply cascade dropdown visibility after back navigation
    if (prevState.selectedForm && prevState.selectedForm.formguid && !this.state.selectedForm.formguid) {
      this.restoreDropdownVisibility();
    }
  }

  restoreDropdownVisibility = () => {
    const fd = this.selectedForm;
    if (!fd || !fd.claimtypeCat) return;

    const isMotor = fd.claimtypeCat === "Motor";

    // Restore Motor vs Non-Motor field visibility
    if (isMotor) {
      $("#root_claimMotorCauseOfLoss").parent().removeClass("hidden");
      $("#root_claimNonMotorCauseOfLoss").parent().addClass("hidden");
      $("#root_CausedBy").parent().removeClass("hidden");
      $("#root_NonMotorCausedBy").parent().addClass("hidden");
      this.setState((prev) => ({ uiSchema: { ...prev.uiSchema, thirdparty: {} } }));
    } else {
      $("#root_claimMotorCauseOfLoss").parent().addClass("hidden");
      $("#root_claimNonMotorCauseOfLoss").parent().removeClass("hidden");
      $("#root_CausedBy").parent().addClass("hidden");
      $("#root_NonMotorCausedBy").parent().removeClass("hidden");
      this.setState((prev) => ({ uiSchema: { ...prev.uiSchema, thirdparty: { classNames: "hidden" } } }));
    }

    // Restore subCoi visibility if a base COI was selected
    if (fd.claimMotor || fd.claimNonMotor) {
      $("#root_subCoi").parent().removeClass("hidden");
    }

    // Restore peril visibility if a subCoi was selected
    if (fd.subCoi) {
      if (isMotor) {
        $("#root_claimMotorCauseOfLoss").parent().removeClass("hidden");
      } else {
        $("#root_claimNonMotorCauseOfLoss").parent().removeClass("hidden");
      }
    }

    // Restore cause visibility if a peril was selected
    if (fd.claimMotorCauseOfLoss || fd.claimNonMotorCauseOfLoss) {
      if (isMotor) {
        $("#root_CausedBy").parent().removeClass("hidden");
      } else {
        $("#root_NonMotorCausedBy").parent().removeClass("hidden");
      }
    }
  };

  getHostConfig = () => {
    const hostname = window.location.hostname;
    for (let host in config.hosts) {
      if (hostname === config.hosts[host].hostname) {
        return config.hosts[host];
      }
    }
    return config.hosts.default || {};
  };

  escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  extractProductTypes = (data) => {
    const collections = [data?.value, data, data?.products, data?.ProductTypes, data?.items, data?.results];
    const source = collections.find((entry) => Array.isArray(entry)) || [];

    const parsed = source
      .map((item) => {
        if (typeof item === "string") {
          return { name: item.trim(), id: Number.MAX_SAFE_INTEGER };
        }

        const name =
          item?.ProductName ||
          item?.productName ||
          item?.productType ||
          item?.ProductType ||
          item?.insuredPerilCode ||
          item?.code ||
          item?.Code ||
          item?.title ||
          item?.Title;
        const parsedId = Number(item?.ProductID ?? item?.productID);

        return {
          name: typeof name === "string" ? name.trim() : "",
          id: Number.isFinite(parsedId) ? parsedId : Number.MAX_SAFE_INTEGER
        };
      })
      .filter((item) => item.name);

    parsed.sort((a, b) => {
      if (a.id !== b.id) {
        return a.id - b.id;
      }

      return a.name.localeCompare(b.name);
    });

    const uniqueProducts = [];
    const seen = new Set();

    parsed.forEach((item) => {
      const key = `${item.name}::${item.id}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueProducts.push(item);
      }
    });

    return uniqueProducts;
  };

  updateProductTypeSchema = (productTypes) => {
    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    const productValues = productTypes.map((product) => product.name);
    const productIdByName = productTypes.reduce((acc, product) => {
      if (Number.isFinite(product.id) && product.id !== Number.MAX_SAFE_INTEGER) {
        acc[product.name] = product.id;
      }
      return acc;
    }, {});

    updatedSchema.properties.insuredPerilCode.enum = productValues;
    updatedSchema.properties.insuredPerilCode.enumNames = productValues;
    updatedSchema.properties.insuredPerilCode.pattern = `^(${productValues
      .map(this.escapeRegex)
      .join("|")})$`;

    this.setState({ formSchema: updatedSchema, productTypeIdByName: productIdByName });
  };

  attachSelectedProductId = (formData) => {
    const selectedProduct = formData?.insuredPerilCode;
    const selectedProductId = this.state.productTypeIdByName[selectedProduct];

    if (selectedProductId !== undefined) {
      formData.ProductID = selectedProductId;
    } else {
      delete formData.ProductID;
    }
  };

  fetchProductTypesFromLogicApp = async (endpoint) => {
    try {
      const postResponse = await axios.post(endpoint, {});
      const postProducts = this.extractProductTypes(postResponse.data);
      if (postProducts.length) {
        return postProducts;
      }
    } catch (error) {
      console.warn("POST product type request failed. Trying GET fallback.");
    }

    try {
      const getResponse = await axios.get(endpoint);
      return this.extractProductTypes(getResponse.data);
    } catch (error) {
      console.warn("GET product type request failed.");
      return [];
    }
  };

  fetchPerils = async (productId) => {
    if (!productId) return;

    const endpoint = this.getHostConfig().getPerilsEndpoint;
    if (!endpoint) {
      console.warn("getPerilsEndpoint not configured.");
      return;
    }

    try {
      const response = await axios.post(endpoint, { ID: productId });
      const data = response.data;
      const source = Array.isArray(data?.value)
        ? data.value
        : Array.isArray(data)
        ? data
        : [];

      const filteredSource = source.filter((item) => {
        const titleValue = item?.Title ?? item?.title;
        if (titleValue === undefined || titleValue === null || titleValue === "") {
          return true;
        }

        return String(titleValue).trim() === String(productId).trim();
      });

      const perilItems = filteredSource
        .map((item) => {
          const label =
            item?.field_2 ||
            item?.PerilName ||
            item?.perilName ||
            item?.Peril ||
            item?.peril ||
            item?.Title ||
            item?.title ||
            "";
          const parsedId = Number(item?.field_1 ?? item?.PerilID ?? item?.perilID ?? item?.ID ?? item?.id);

          return {
            label: typeof label === "string" ? label.trim() : "",
            id: Number.isFinite(parsedId) ? parsedId : undefined
          };
        })
        .filter((item) => item.label);

      const perilIdByName = {};
      perilItems.forEach((item) => {
        if (item.id !== undefined && perilIdByName[item.label] === undefined) {
          perilIdByName[item.label] = item.id;
        }
      });

      const perils = [...new Set(perilItems.map((item) => item.label))].sort((a, b) =>
        a.localeCompare(b)
      );

      if (!perils.length) {
        console.warn("Peril response returned no items for ProductID:", productId);
        return;
      }

      this.setState({ perilIdByName });
      this.updatePerilSchema(perils);
    } catch (error) {
      console.warn("Failed to fetch perils for ProductID:", productId, error);
    }
  };

  extractCauses = (data, perilId) => {
    const sourceCandidates = [data?.value, data?.body?.value, data?.body, data?.results, data];
    const source = sourceCandidates.find((entry) => Array.isArray(entry)) || [];

    const filteredSource = source.filter((item) => {
      const perilValue = item?.field_1 ?? item?.PerilID ?? item?.perilID;
      if (perilValue === undefined || perilValue === null || perilValue === "") {
        return true;
      }

      return String(perilValue).trim() === String(perilId).trim();
    });

    const causeIdByName = {};
    const causeNames = filteredSource
      .map((item) => {
        const name = (
          item?.PerilDesc ||
          item?.field_3 ||
          item?.CauseName ||
          item?.causeName ||
          item?.Cause ||
          item?.cause ||
          item?.Title ||
          item?.title ||
          item?.Description ||
          item?.description ||
          item?.field_4 ||
          item?.field_2 ||
          ""
        );
        const trimmedName = typeof name === "string" ? name.trim() : "";
        if (trimmedName) {
          const rawId = item?.field_2 ?? item?.CauseID ?? item?.causeID ?? item?.field_4 ?? item?.ID ?? item?.id;
          const parsedId = rawId !== undefined && rawId !== null ? Number(rawId) : undefined;
          if (causeIdByName[trimmedName] === undefined && parsedId !== undefined && Number.isFinite(parsedId)) {
            causeIdByName[trimmedName] = parsedId;
          }
        }
        return trimmedName;
      })
      .filter(Boolean);

    const causes = [...new Set(causeNames)].sort((a, b) => a.localeCompare(b));

    return { causes, causeIdByName };
  };

  updateClaimMotorSchema = (items) => {
    if (!items.length) return;

    const isMotor = (item) =>
      String(item?.Title ?? "").toLowerCase().startsWith("motor");

    const getId = (item) =>
      String(item?.field_2 ?? item?.Id ?? item?.ID ?? item?.id ?? item?.Title);

    const motorItems = items.filter(isMotor);
    const nonMotorItems = items.filter((item) => !isMotor(item));

    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));

    if (motorItems.length && Array.isArray(updatedSchema?.dependencies?.claimtypeCat?.oneOf)) {
      updatedSchema.dependencies.claimtypeCat.oneOf.forEach((branch) => {
        if (branch?.properties?.claimMotor) {
          branch.properties.claimMotor.enum = motorItems.map(getId);
          branch.properties.claimMotor.enumNames = motorItems.map((item) => item.Title);
        }
      });
    }

    if (nonMotorItems.length && Array.isArray(updatedSchema?.dependencies?.claimtypeCat?.oneOf)) {
      updatedSchema.dependencies.claimtypeCat.oneOf.forEach((branch) => {
        if (branch?.properties?.claimNonMotor) {
          branch.properties.claimNonMotor.enum = nonMotorItems.map(getId);
          branch.properties.claimNonMotor.enumNames = nonMotorItems.map((item) => item.Title);
        }
      });
    }

    this.setState({ formSchema: updatedSchema });
  };

  updatePerilSchemaFromSubCoi = (items) => {
    if (!items.length) return;

    const seen = new Set();
    const uniqueItems = items.filter((item) => {
      if (seen.has(item.PerilDesc)) return false;
      seen.add(item.PerilDesc);
      return true;
    });

    // Use PerilDesc as enum value so perilIdByName lookup in handleFieldChange resolves correctly
    const enumValues = uniqueItems.map((item) => item.PerilDesc);
    const enumNames = uniqueItems.map((item) => item.PerilDesc);

    const perilIdByName = {};
    uniqueItems.forEach((item) => {
      perilIdByName[item.PerilDesc] = item.peril;
    });

    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    updatedSchema.properties.claimMotorCauseOfLoss.enum = enumValues;
    updatedSchema.properties.claimMotorCauseOfLoss.enumNames = enumNames;
    updatedSchema.properties.claimNonMotorCauseOfLoss.enum = enumValues;
    updatedSchema.properties.claimNonMotorCauseOfLoss.enumNames = enumNames;

    if (Array.isArray(updatedSchema?.dependencies?.claimNonMotor?.oneOf)) {
      updatedSchema.dependencies.claimNonMotor.oneOf.forEach((branch) => {
        if (branch?.properties?.claimNonMotorCauseOfLoss) {
          branch.properties.claimNonMotorCauseOfLoss.enum = enumValues;
          branch.properties.claimNonMotorCauseOfLoss.enumNames = enumNames;
        }
      });
    }

    if (Array.isArray(updatedSchema?.dependencies?.claimtypeCat?.oneOf)) {
      updatedSchema.dependencies.claimtypeCat.oneOf.forEach((branch) => {
        if (branch?.properties?.claimMotorCauseOfLoss) {
          branch.properties.claimMotorCauseOfLoss.enum = enumValues;
          branch.properties.claimMotorCauseOfLoss.enumNames = enumNames;
        }
      });
    }

    this.setState({ formSchema: updatedSchema, perilIdByName }, () => {
      const isNonMotor = this.selectedForm?.claimtypeCat === "Non-Motor";
      if (isNonMotor) {
        $("#root_claimNonMotorCauseOfLoss").parent().removeClass("hidden");
        $("#root_claimNonMotorCauseOfLoss").prop("selectedIndex", 0);
      } else {
        $("#root_claimMotorCauseOfLoss").parent().removeClass("hidden");
        $("#root_claimMotorCauseOfLoss").prop("selectedIndex", 0);
      }
    });
  };

  fetchPerilsFromSubCoi = async (productId, baseCoiId, subCoiId) => {
    if (!productId || !baseCoiId || !subCoiId) return;

    const endpoint = this.getHostConfig().getPerilsEndpoint;
    if (!endpoint) {
      console.warn("getPerilsEndpoint not configured.");
      return;
    }

    this.setState({ loadingPeril: true });
    try {
      const response = await axios.post(endpoint, {
        productID: String(productId),
        baseCoiID: String(baseCoiId),
        subCoiID: String(subCoiId)
      });
      const data = response.data;
      const items = Array.isArray(data) ? data : Array.isArray(data?.value) ? data.value : [];
      this.updatePerilSchemaFromSubCoi(items);
    } catch (error) {
      console.warn("Failed to fetch perils for subCoiID:", subCoiId, error);
    } finally {
      this.setState({ loadingPeril: false });
    }
  };

  updateSubCoiSchema = (items) => {
    if (!items.length) return;

    const getId = (item) =>
      String(item?.field_3 ?? item?.Id ?? item?.ID ?? item?.field_2 ?? item?.id ?? "");

    const enumValues = items.map(getId);
    const enumNames = items.map((item) => item?.field_2 ?? item?.Title ?? item?.title ?? "");

    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    updatedSchema.properties.subCoi.enum = enumValues;
    updatedSchema.properties.subCoi.enumNames = enumNames;

    this.setState({ formSchema: updatedSchema }, () => {
      $("#root_subCoi").parent().removeClass("hidden");
      $("#root_subCoi").prop("selectedIndex", 0);
    });
  };

  fetchSubCoi = async (productId, baseCoiId) => {
    if (!productId || !baseCoiId) return;

    const endpoint = this.getHostConfig().getSubCoiEndpoint;
    if (!endpoint) {
      console.warn("getSubCoiEndpoint not configured.");
      return;
    }

    this.setState({ loadingSubCoi: true });
    try {
      const payload = {
        productID: String(productId),
        baseCoiID: String(baseCoiId)
      };
      console.log("fetchSubCoi payload:", JSON.stringify(payload));
      const response = await axios.post(endpoint, payload);
      const data = response.data;
      console.log("Sub COI raw response:", JSON.stringify(data, null, 2));
      const items = Array.isArray(data) ? data : Array.isArray(data?.value) ? data.value : [];
      this.updateSubCoiSchema(items);
    } catch (error) {
      console.warn("Failed to fetch sub-COI options for BaseCoiID:", baseCoiId, error);
    } finally {
      this.setState({ loadingSubCoi: false });
    }
  };

  fetchMotorOptions = async (productId) => {
    if (!productId) return;

    const endpoint = this.getHostConfig().getProductMappingEndpoint;
    if (!endpoint) {
      console.warn("getProductMappingEndpoint not configured.");
      return;
    }

    try {
      const response = await axios.post(endpoint, { ID: productId });
      const data = response.data;
      const items = Array.isArray(data) ? data : Array.isArray(data?.value) ? data.value : [];
      this.updateClaimMotorSchema(items);
    } catch (error) {
      console.warn("Failed to fetch motor options for ProductID:", productId, error);
    }
  };

  fetchCauses = async (perilId, productId, baseCoiId, subCoiId) => {
    if (!perilId) {
      return;
    }

    const endpoint = this.getHostConfig().getCausesEndpoint;
    if (!endpoint) {
      console.warn("getCausesEndpoint not configured.");
      return;
    }

    this.setState({ loadingCauses: true });
    try {
      const response = await axios.post(endpoint, {
        productID: String(productId || ""),
        baseCoiID: String(baseCoiId || ""),
        subCoiID: String(subCoiId || ""),
        perilID: String(perilId)
      });
      const { causes, causeIdByName } = this.extractCauses(response.data, perilId);

      if (!causes.length) {
        console.warn("Cause response returned no items for PerilID:", perilId);
        return;
      }

      this.setState({ causeIdByName });
      this.updateCauseSchema(causes);
    } catch (error) {
      console.warn("Failed to fetch causes for PerilID:", perilId, error);
    } finally {
      this.setState({ loadingCauses: false });
    }
  };

  // Resets peril enum and cause code enum to empty, then hides the Cause Code fields.
  // Called when Base COI changes so stale peril/cause options don't persist.
  resetPerilAndCauseSchema = () => {
    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    const empty = [""];
    updatedSchema.properties.claimMotorCauseOfLoss.enum = empty;
    updatedSchema.properties.claimNonMotorCauseOfLoss.enum = empty;
    updatedSchema.properties.CausedBy.enum = empty;
    updatedSchema.properties.NonMotorCausedBy.enum = empty;
    this.setState({ formSchema: updatedSchema });
  };

  // Resets only the cause code enum to empty.
  // Called when Sub COI changes so stale cause options don't persist while new perils load.
  resetCauseSchema = () => {
    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    const empty = [""];
    updatedSchema.properties.CausedBy.enum = empty;
    updatedSchema.properties.NonMotorCausedBy.enum = empty;
    this.setState({ formSchema: updatedSchema });
  };

  updateCauseSchema = (causes) => {
    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    const causeEnum = causes.length ? causes : [""];

    updatedSchema.properties.CausedBy.enum = causeEnum;
    updatedSchema.properties.CausedBy.enumNames = causeEnum;
    updatedSchema.properties.NonMotorCausedBy.enum = causeEnum;
    updatedSchema.properties.NonMotorCausedBy.enumNames = causeEnum;

    // Keep non-motor dependency branches synchronized to avoid empty enum overrides.
    if (Array.isArray(updatedSchema?.dependencies?.claimNonMotor?.oneOf)) {
      updatedSchema.dependencies.claimNonMotor.oneOf.forEach((branch) => {
        if (branch?.properties?.NonMotorCausedBy) {
          branch.properties.NonMotorCausedBy.enum = causeEnum;
          branch.properties.NonMotorCausedBy.enumNames = causeEnum;
        }
      });
    }

    if (Array.isArray(updatedSchema?.dependencies?.claimtypeCat?.oneOf)) {
      updatedSchema.dependencies.claimtypeCat.oneOf.forEach((branch) => {
        if (branch?.properties?.CausedBy) {
          branch.properties.CausedBy.enum = causeEnum;
          branch.properties.CausedBy.enumNames = causeEnum;
        }
      });
    }

    this.setState({ formSchema: updatedSchema }, () => {
      const claimtypeCat = this.selectedForm?.claimtypeCat;
      if (claimtypeCat === "Motor") {
        $("#root_CausedBy").parent().removeClass("hidden");
        $("#root_CausedBy").prop("selectedIndex", 0);
      } else {
        $("#root_NonMotorCausedBy").parent().removeClass("hidden");
        $("#root_NonMotorCausedBy").prop("selectedIndex", 0);
      }
    });
  };

  updatePerilSchema = (perils) => {
    const updatedSchema = JSON.parse(JSON.stringify(this.state.formSchema));
    const perilEnum = perils.length ? perils : [""];

    updatedSchema.properties.claimNonMotorCauseOfLoss.enum = perils;
    updatedSchema.properties.claimNonMotorCauseOfLoss.enumNames = perils;
    updatedSchema.properties.claimMotorCauseOfLoss.enum = perils;
    updatedSchema.properties.claimMotorCauseOfLoss.enumNames = perils;

    // Keep dependency branches synchronized so jsonschema dependencies do not overwrite dynamic perils.
    if (Array.isArray(updatedSchema?.dependencies?.claimNonMotor?.oneOf)) {
      updatedSchema.dependencies.claimNonMotor.oneOf.forEach((branch) => {
        if (branch?.properties?.claimNonMotorCauseOfLoss) {
          branch.properties.claimNonMotorCauseOfLoss.enum = perilEnum;
          branch.properties.claimNonMotorCauseOfLoss.enumNames = perilEnum;
        }
      });
    }

    if (Array.isArray(updatedSchema?.dependencies?.claimtypeCat?.oneOf)) {
      updatedSchema.dependencies.claimtypeCat.oneOf.forEach((branch) => {
        if (branch?.properties?.claimMotorCauseOfLoss) {
          branch.properties.claimMotorCauseOfLoss.enum = perilEnum;
          branch.properties.claimMotorCauseOfLoss.enumNames = perilEnum;
        }
      });
    }

    this.setState({ formSchema: updatedSchema });
  };

  fetchProductTypes = async () => {
    const hostConfig = this.getHostConfig();
    const endpoint =
      hostConfig.getProductTypesEndpoint || hostConfig.getProductsEndpoint || hostConfig.getFormEndpoint;

    if (!endpoint) {
      return;
    }

    try {
      const productTypes = await this.fetchProductTypesFromLogicApp(endpoint);

      if (!productTypes.length) {
        return;
      }

      this.updateProductTypeSchema(productTypes);
      this.setState({ productTypesLoaded: true });
    } catch (error) {
      console.warn("Unable to load product types from Logic App. Using default schema values.");
    }
  };

  // TODO: move to utils
  validateTelNumbers = (formData, errors) => {
    const phoneno = /^\d{10}$/;
    // FIXME: is it possible to use a universal telephone type to flag telephone number validations instead of hardcoding? if not move to a config file
    const telephoneKeys = ["brokertel", "insuredtel"];

    telephoneKeys.forEach((element) => {
      //console.log(element);
      if (formData.hasOwnProperty(element) && formData[element]) {
        if (!formData[element].match(phoneno)) {
          errors[element].addError("Not a valid contact number.");
        }
      }
    });
    return errors;
  };

  handleGoBack = () => {
    this.props.clearFormSelectionData();
    this.selectedForm = { ...this.selectedForm, formguid: null };
    this.setState({ selectedForm: {} });
  };

  handleFormSelection = ({ formData }, e) => {
    // TODO: move formselection logic out of AppRouter
    const fD = { ...formData }; // Create a deep copy of formdata
    this.attachSelectedProductId(fD);

    // Attach resolved numeric IDs for the COI hierarchy so they are included in the submission payload.
    const isMotor = fD.claimtypeCat === "Motor";
    const baseCoiId = fD.claimMotor || fD.claimNonMotor;
    if (baseCoiId !== undefined && baseCoiId !== null && baseCoiId !== "") fD.BaseCoiID = baseCoiId;
    if (this.state.previousSubCoiId !== undefined && this.state.previousSubCoiId !== null) fD.SubCoiID = this.state.previousSubCoiId;
    if (this.state.previousPerilId !== undefined && this.state.previousPerilId !== null) fD.PerilID = this.state.previousPerilId;
    const selectedCauseName = isMotor ? fD.CausedBy : fD.NonMotorCausedBy;
    const causeId = selectedCauseName ? this.state.causeIdByName[selectedCauseName] : undefined;
    if (causeId !== undefined) fD.CauseID = causeId;

    fD.formguid = uuidv4(); // Generate new guid (uuid/v4)
    this.setState({ selectedForm: fD }); // Save formdata to state
    this.selectedForm = fD;
    this.props.setFormSelectionData(fD);
    console.log(fD);
    console.log("form selected:", this.state.selectedForm);
    const claimtypeCat = formData.claimtypeCat || "";
    const claimMotorCauseOfLoss = formData.claimMotorCauseOfLoss || "";
    const causedBy = formData.CausedBy || "";

    if (
      claimMotorCauseOfLoss === "Vehicle - Roadside Assistance" &&
      causedBy === "Mechanical Breakdown"
    ) {
      $("#root_incidentDriverDrugTest").parent().attr("hidden");
    }
    if (claimMotorCauseOfLoss === "Vehicle - Glass") {
      $("#root_incidentDriverDrugTest").parent().attr("hidden");
    }
  };

  handleFieldChange = (event) => {
    log("changes");
    const formData = event.formData;
    this.attachSelectedProductId(event.formData);
    var str = "";

    // Fetch perils when Product Type selection changes
    const selectedProduct = formData?.insuredPerilCode;
    const selectedProductId = selectedProduct ? this.state.productTypeIdByName[selectedProduct] : undefined;
    if (selectedProductId !== undefined && selectedProductId !== this.state.previousProductId) {
      this.setState({ previousProductId: selectedProductId });
      this.fetchMotorOptions(selectedProductId);
    }

    const selectedPeril = formData?.claimMotorCauseOfLoss || formData?.claimNonMotorCauseOfLoss;
    const selectedPerilId = selectedPeril ? this.state.perilIdByName[selectedPeril] : undefined;

    if (selectedPerilId !== undefined && selectedPerilId !== this.state.previousPerilId) {
      formData.PerilID = selectedPerilId;
      this.setState({ previousPerilId: selectedPerilId });
      const baseCoiIdForCauses = formData.claimtypeCat === "Non-Motor"
        ? this.state.previousClaimNonMotorId
        : this.state.previousClaimMotorId;
      this.fetchCauses(
        selectedPerilId,
        this.state.previousProductId,
        baseCoiIdForCauses,
        this.state.previousSubCoiId
      );
    }

    const selectedClaimMotorId = formData?.claimMotor;
    if (selectedClaimMotorId !== undefined && selectedClaimMotorId !== this.state.previousClaimMotorId) {
      this.setState({ previousClaimMotorId: selectedClaimMotorId, previousSubCoiId: null, previousPerilId: null });
      // Clear downstream stale values from form state
      delete this.selectedForm.subCoi;
      delete this.selectedForm.claimMotorCauseOfLoss;
      delete this.selectedForm.CausedBy;
      // Reset downstream schema enums
      this.resetPerilAndCauseSchema();
      // Hide dependent dropdowns
      $("#root_subCoi").parent().addClass("hidden");
      $("#root_claimMotorCauseOfLoss").parent().addClass("hidden");
      $("#root_CausedBy").parent().addClass("hidden");
      this.fetchSubCoi(this.state.previousProductId, selectedClaimMotorId);
    }

    const selectedClaimNonMotorId = formData?.claimNonMotor;
    if (selectedClaimNonMotorId !== undefined && selectedClaimNonMotorId !== this.state.previousClaimNonMotorId) {
      this.setState({ previousClaimNonMotorId: selectedClaimNonMotorId, previousSubCoiId: null, previousPerilId: null });
      // Clear downstream stale values from form state
      delete this.selectedForm.subCoi;
      delete this.selectedForm.claimNonMotorCauseOfLoss;
      delete this.selectedForm.NonMotorCausedBy;
      // Reset downstream schema enums
      this.resetPerilAndCauseSchema();
      // Hide dependent dropdowns
      $("#root_subCoi").parent().addClass("hidden");
      $("#root_claimNonMotorCauseOfLoss").parent().addClass("hidden");
      $("#root_NonMotorCausedBy").parent().addClass("hidden");
      this.fetchSubCoi(this.state.previousProductId, selectedClaimNonMotorId);
    }

    const selectedSubCoiId = formData?.subCoi;
    if (selectedSubCoiId !== undefined && selectedSubCoiId !== this.state.previousSubCoiId) {
      this.setState({ previousSubCoiId: selectedSubCoiId, previousPerilId: null });
      // Clear stale peril and cause code values from form state
      delete this.selectedForm.claimMotorCauseOfLoss;
      delete this.selectedForm.claimNonMotorCauseOfLoss;
      delete this.selectedForm.CausedBy;
      delete this.selectedForm.NonMotorCausedBy;
      // Reset cause code schema enums and hide cause code fields
      this.resetCauseSchema();
      $("#root_CausedBy").parent().addClass("hidden");
      $("#root_NonMotorCausedBy").parent().addClass("hidden");

      // Show/hide thirdparty for Non-Motor liability sub-COI
      if (formData.claimtypeCat === "Non-Motor") {
        const subCoiEnum = this.state.formSchema?.properties?.subCoi?.enum || [];
        const subCoiEnumNames = this.state.formSchema?.properties?.subCoi?.enumNames || [];
        const nameIdx = subCoiEnum.indexOf(selectedSubCoiId);
        const subCoiName = nameIdx >= 0 ? (subCoiEnumNames[nameIdx] || "") : "";
        if (subCoiName.toLowerCase().includes("liability")) {
          this.setState((prev) => ({ uiSchema: { ...prev.uiSchema, thirdparty: {} } }));
        } else {
          delete this.selectedForm.thirdparty;
          this.setState((prev) => ({ uiSchema: { ...prev.uiSchema, thirdparty: { classNames: "hidden" } } }));
        }
      }

      const baseCoiId = formData.claimtypeCat === "Non-Motor"
        ? this.state.previousClaimNonMotorId
        : this.state.previousClaimMotorId;
      this.fetchPerilsFromSubCoi(
        this.state.previousProductId,
        baseCoiId,
        selectedSubCoiId
      );
    }

    // Check if claimNonMotorCauseOfLoss value has changed

    this.handleclaimtypeCatChange(event);

    // Keep insuredPolicyNumber user-controlled; do not auto-prefix or reset it.
    if ($("#root_CausedBy").val() === "Single Vehicle Accident") {
      $("#root_thirdparty").removeAttr("required");
      $("#root_thirdparty_thirdpartyInvolved").removeAttr("required");
      $("#root_thirdparty_thirdpartyInvolved")
        .closest(".form-group")
        .removeClass("field-error text-danger")
        .find(".error-detail")
        .remove();
      $("#root_thirdparty_thirdpartyInvolved").closest("div").find("label .required").remove();
    }

    // Check claim type category = Motor
    if (event.formData.claimtypeCat === "Motor") {
      //Show third party section if Accident Collision selected
      var selected = $("#root_claimMotor :selected").text();

      //hidden controls

      const claimMotorCauseOfLoss = event.formData.claimMotorCauseOfLoss || "";
      const causedBy = event.formData.CausedBy || "";

      // Third Party visibility is controlled by uiSchema state in handleclaimtypeCatChange.
      // Only manage auxiliary field visibility here.
      if (claimMotorCauseOfLoss === "Vehicle - Theft" && causedBy === "Vehicle - Hijack") {
        try {
          $("#root_incidentDriverDrugTest").removeAttr("required");
          $("#root_incidentDriverDrugTest").attr("hidden", true);
        } catch (error) {
          console.log("Error removing required attributes: ", error);
        }
      }
      if (claimMotorCauseOfLoss === "Vehicle - Theft" && causedBy === "Vehicle - Hijack") {
        $("#root_thirdparty_thirdpartyOther_thirdpartyHaveDetailsNote")
          .parent()
          .attr("hidden", true);
      }


      if (
        claimMotorCauseOfLoss === "Vehicle - Roadside Assistance" &&
        causedBy === "Mechanical Breakdown"
      ) {
        $("#root_incidentDriverDrugTest").parent().attr("hidden");
      }
      if (claimMotorCauseOfLoss === "Vehicle - Glass") {
        $("#root_incidentDriverDrugTest").parent().attr("hidden");
      }
      var selectedmotor = "$root_";
      str = event.formData.claimMotor;
    }

    // Check claim type category = Non-Motor
    if (event.formData.claimtypeCat === "Non-Motor") {
      $("#root_claimMotorCauseOfLoss").parent().addClass("hidden");
      $("#root_claimNonMotorCauseOfLoss").parent().removeClass("hidden");

      str = event.formData.claimNonMotor;
    } else {
      $("#root_claimMotorCauseOfLoss").parent().removeClass("hidden");
      $("#root_claimNonMotorCauseOfLoss").parent().addClass("hidden");
    }
  };

  handleclaimtypeCatChange = (event) => {
    const claimTypeCategory = event?.formData?.claimtypeCat;

    // Keep cause-code sections in sync with selected claim category.
    if (claimTypeCategory === "Motor") {
      $("#root_NonMotorCausedBy").parent().addClass("hidden");
      $("#root_CausedBy").parent().removeClass("hidden");
      this.setState((prev) => ({
        uiSchema: { ...prev.uiSchema, thirdparty: {} }
      }));
    } else {
      $("#root_NonMotorCausedBy").parent().removeClass("hidden");
      $("#root_CausedBy").parent().addClass("hidden");
      this.setState((prev) => ({
        uiSchema: { ...prev.uiSchema, thirdparty: { classNames: "hidden" } }
      }));
    }

    // Remove duplicate empty select options generated by repeated rerenders.
    ["#root_claimNonMotorCauseOfLoss", "#root_claimNonMotor"].forEach((selector) => {
      $(selector).each(function () {
        const emptyOptions = $(this)
          .find("option")
          .filter(function () {
            return !$(this).val().trim() && !$(this).text().trim();
          });

        if (emptyOptions.length > 1) {
          emptyOptions.slice(1).remove();
        }
      });
    });

    this.selectedForm = { ...event.formData };
    this.setState({ selectedForm: this.selectedForm });
  };

  render() {
    const { selectedForm, formSchema, loadingCauses, loadingSubCoi, loadingPeril, uiSchema } = this.state;

    // TODO: move formselection logic out of AppRouter
    /* TODO: move component definitions inside below switch statement, 
        no need to have a seperate component for each form, 
        just need to pass the form's schema, 
        uiSchemas and formdata here instead of the component, 
        use a standard wizard wrapper component to contain Wizard components */
    let selectedFormComponent;
    switch (selectedForm.claimtypeCat) {
      case "Non-Motor":
        selectedFormComponent = <Geyser selectFormData={this.selectedForm} onBack={this.handleGoBack} />;
        break;
      case "Motor":
        selectedFormComponent = <VehicleCollision selectFormData={this.selectedForm} onBack={this.handleGoBack} />;
        break;
      default:
        selectedFormComponent = <div>no form selected</div>;
        break;
    }
    const formSelect = (
      <div>
        <Form
          schema={formSchema}
          uiSchema={uiSchema || baseUiSchema}
          formData={this.selectedForm}
          onChange={this.handleFieldChange}
          onSubmit={this.handleFormSelection.bind(this)}
          onError={log("errors")}
          validate={this.validateTelNumbers}
          claimtypeCatchange={this.handleclaimtypeCatChange}
        >
          <div>
            {loadingSubCoi && (
              <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                <div
                  className="spinner-border spinner-border-sm text-secondary"
                  role="status"
                  style={{ marginRight: "8px" }}
                >
                  <span className="sr-only">Loading sub COI...</span>
                </div>
                <span>Loading sub COI options...</span>
              </div>
            )}
            {loadingPeril && (
              <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                <div
                  className="spinner-border spinner-border-sm text-info"
                  role="status"
                  style={{ marginRight: "8px" }}
                >
                  <span className="sr-only">Loading perils...</span>
                </div>
                <span>Loading peril codes...</span>
              </div>
            )}
            {loadingCauses && (
              <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                  style={{ marginRight: "8px" }}
                >
                  <span className="sr-only">Loading causes...</span>
                </div>
                <span>Loading cause codes...</span>
              </div>
            )}
            <button className="btn btn-primary" type="submit">
              Next
            </button>
          </div>
        </Form>
      </div>
    );

    return <div>{this.state.selectedForm.formguid ? selectedFormComponent : formSelect}</div>;
  }
}

const mapStateToProps = (state) => ({
  formSelectionData: state.formSelectionData
});

const mapDispatchToProps = {
  setFormSelectionData,
  clearFormSelectionData
};

export default connect(mapStateToProps, mapDispatchToProps)(FormSelection);
